import { render } from "./ItemEditBasicInfo.vue?vue&type=template&id=d3e9a960&scoped=true&bindings={\"modelValue\":\"props\",\"item\":\"data\",\"sites\":\"data\",\"siteUrl\":\"data\",\"selectedFileText\":\"data\",\"siteUrlDomain\":\"options\",\"siteSuggestionsSourceUrl\":\"options\",\"getSites\":\"options\",\"sitePageSelect\":\"options\",\"setItemData\":\"options\",\"imageChange\":\"options\",\"removeImage\":\"options\"}"
import script from "./ItemEditBasicInfo.vue?vue&type=script&lang=js"
export * from "./ItemEditBasicInfo.vue?vue&type=script&lang=js"

import "./ItemEditBasicInfo.vue?vue&type=style&index=0&id=d3e9a960&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3e9a960"

export default script